import { NgModule } from '@angular/core';
import { SafePipe } from "./safe.pipe";

@NgModule({
  imports: [
    // dep modules
  ],
  declarations: [
    SafePipe
  ],
  exports: [
    SafePipe
  ]
})
export class ApplicationPipesModule {}



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/components/pipes/safe.module.ts